import React from "react";

const ViewDataSystems = () => {
  return <div>ViewDataSystems</div>;
};

export default ViewDataSystems;
